import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaColorPalette from './VaColorPalette.vue'

export const VaColorPalette = withConfigTransport(_VaColorPalette)
